import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import FellowshipDetail from '@/views/FellowshipDetail'
import PlayerDetail from '@/views/PlayerDetail'
import Contact from '@/views/Contact'
import Faq from '@/views/Faq'
import PrivacyPolicy from '@/views/PrivacyPolicy'
import VuetifyTest from '@/components/VuetifyTest'
import Thanks from '@/views/Thanks'
import Donate from '@/views/Donate'
import ThankYouForDonating from '@/views/ThankYouForDonating'
import Tournaments from '@/views/Tournaments'
import Players from '@/views/Players'
import Fellowships from '@/views/Fellowships'
import PlayerElvenArchitect from '@/views/PlayerElvenArchitect'
import ChangePlayer from '@/views/ChangePlayer'
import News from '@/views/news'
import TranslationInstructions from '@/views/TranslatationInstructions'
import MatchMakerFindFellowship from '@/views/MatchMakerFindFellowship'
import MatchMakerFindUsers from '@/views/MatchMakerFindUsers'

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
        },
        {
            path: '/thanks',
            name: 'Thanks',
            component: Thanks
        },
        {
            path: '/thanks-for-donating',
            name: 'ThankYouForDonating',
            component: ThankYouForDonating
        },
        {
            path: '/donate',
            name: 'Donate',
            component: Donate
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/faq',
            name: 'Faq',
            component: Faq
        },
        {
            path: '/news',
            name: 'News',
            component: News
        },
        {
            path: '/privacy-policy',
            name: 'PrivacyPolicy',
            component: PrivacyPolicy
        },
        {
            path: '/tournaments',
            name: 'Tournaments',
            component: Tournaments
        },
        {
            path: '/players',
            name: 'Players',
            component: Players
        },
        {
            path: '/changePlayer',
            name: 'ChangePlayer',
            component: ChangePlayer
        },
        {
            path: '/fellowships',
            name: 'Fellowships',
            component: Fellowships
        },
        {
            path: '/translation-instructions',
            name: 'Translation Instructions',
            component: TranslationInstructions
        },
        {
            path: '/fellowship/:server/:fellowshipId',
            name: 'FellowshipDetail',
            component: FellowshipDetail,
            props: true
        },
        {
            path: '/player/:server/:playerId',
            name: 'PlayerDetail',
            component: PlayerDetail,
            props: true
        },
        {
            path: '/matchmaker/find/fellowship',
            name: 'MatchMakerFindFellowship',
            component: MatchMakerFindFellowship,
            props: true
        },
        {
            path: '/matchmaker/find/user',
            name: 'MatchMakerFindUsers',
            component: MatchMakerFindUsers,
            props: true
        },
        {
            path: '/player/:server/:playerId/elvenarchitect',
            name: 'PlayerElvenArchitect',
            component: PlayerElvenArchitect,
            props: true
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js